import useInit from 'hooks/useInit';
import Header from 'components/Header';
import Main from 'components/Main';
import Dialog from 'components/Dialog';

function App() {
  useInit();

  return (
    <>
      <Main />

      <Header />

      <Dialog />
    </>
  );
}

export default App;
